import * as React from "react";

const IconLinkCaretUp: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="currentColor"><polygon fill="currentColor" points="27.28 4.809 27.545 4.545 31.295 .795 31.559 .53 31.03 0 30.765 .265 27.28 3.75 23.795 .265 23.53 0 23 .53 23.265 .795 27.015 4.545"  transform="matrix(1 0 0 -1 -22.03 5.28)"/></svg>;
};

export default React.memo(IconLinkCaretUp);
